module.exports = __webpack_public_path__ + "static/img/3_v2.2d0b6ff6.png";